import {CustomerSubscriptionInfoBoxesFragment} from '#apollo/schema';

export const getSubscriptionDiscountCodes = (
  subscription: CustomerSubscriptionInfoBoxesFragment,
): string[] => {
  if (!subscription) return [];
  return subscription?.discounts?.reduce<string[]>((acc, discount) => {
    if (discount.category.toUpperCase() === 'CODE') {
      acc.push(discount.title || '');
    }
    return acc;
  }, []);
};
